import { selectCourseMetadataContext } from "./course-context";

import { t } from "i18n/i18n";
import { RootState } from "store/index";
import { selectCourses } from "store/selectors";

export const ORG_VIEW_EXPLANATION_CONTEXT = t("ai.org_view_explanation_long");

export const ORG_COURSE_STRUCTURE_EXPLANATION_CONTEXT = t("ai.org_course_structure_explanation");

export const selectCourseListContext = (state: RootState) => {
  const courses = selectCourses(state);
  const lines = courses.map((course) => selectCourseMetadataContext(state, course)).join("\n");

  return t("ai.org_courses_available", { courses: lines });
};
